import { useEffect } from 'react';

export default function useBodyClass(className) {
  useEffect(() => {
    if (!className) return;
    const $body = document.getElementsByTagName('body')[0];

    $body.classList.add(className);
    return () => $body.classList.remove(className);
  }, [className]);
}
